import React from "react";

import style from "./Tech.css";
import Static from "src/lib/Static";
import Button from "component/Button";
import Team from "component/Team";
import TechLogos from "./TechLogos";


const Tech = ({}) => {
  const content = Static.pages.tech;
  const teamIdx = Static.teams.findIndex((team) => team.name === "Technology");
  const url = `/openings?department=${teamIdx}`;
  const teams = [Static.teams[teamIdx]];

  return (
    <div>
      <div className={style.hero} />
      <div className={style.content}>
        <div className={style.introRow}>
          <div
            className={style.aboutText}
            dangerouslySetInnerHTML={{ __html: content.about.body }}
          />
          <div className={style.rightCol}>
            <img
              className={style.img}
              src="/img/jobs/tech/careers-tech-product.png" />
          </div>
        </div>
      </div>
      <div className={style.culture}>
        <div className={style.content}>
          <div className={style.row}>
            <div className={style.leftCol}>
              <img className={style.img} src={content.culture.image} />
            </div>
            <div className={style.rightCol}>
              <h3 className={style.contentTitle}>
                {content.culture.title}
              </h3>
              <div
                className={style.text}
                dangerouslySetInnerHTML={{ __html: content.culture.body }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={style.content}>
        <div className={style.row}>
          <div className={style.stack}>
            <h3 className={style.contentTitle}>
              {content.stack.title}
            </h3>
            <div
              className={style.text}
              dangerouslySetInnerHTML={{ __html: content.stack.body }}
            />
          </div>
        </div>
      </div>
      <TechLogos logos={content.stack.logos} />
      <div className={style.content}>
        <div className={style.row}>
          <div className={style.stack}>
            <p
              className={style.text}
              dangerouslySetInnerHTML={{ __html: content.stack.body2 }}
            />
            <p
              className={style.text}
              dangerouslySetInnerHTML={{ __html: content.stack.body3 }}
            />
          </div>
        </div>
      </div>
      <Team
        teams={teams}
        headerStyle={{ color: "#002360" }}
      />
      <div className={style.join}>
        <div className={style.content}>
          <div className={style.row}>
            <div className={style.joinContent}>
              <div
                className={style.joinText}
                dangerouslySetInnerHTML={{ __html: content.stack.join.body }}
              />
            </div>
            <div className={style.joinContent}>
              <Button
                to={url}
                label={"Join the team"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tech;



// WEBPACK FOOTER //
// ./component/Tech/index.js